"use client";
import dynamic from 'next/dynamic';
import { ToolSkeleton } from '@/components/ui/ToolSkeleton';

const OddPagesExtractorClient = dynamic(() => import('./OddPagesExtractorClient'), { ssr: false, loading: () => <ToolSkeleton /> });

export default function OddPagesExtractorClientWrapper() {
  return <OddPagesExtractorClient />;
}
